import useSubscriptionPricing from '../../../hooks/useSubscriptionPricing.ts'
import Loader from '../../common/Loader/Loader.tsx'
import SubscriptionsList from './SubscriptionsList.tsx'

const SubscriptionPopup = () => {
  const { loading, prices, customerId } = useSubscriptionPricing()

  return (
    <>
      <div
        className={`p-8 text-[18px] ${loading ? 'flex flex-1 justify-center items-center' : ''} }`}
      >
        {loading && <Loader label={'Pobieranie planów subskrypcji...'} />}
        {!loading && prices && customerId && (
          <div>
            <h2 className={'text-[24px]'}>Wybierz plan subskrypcji</h2>
            <SubscriptionsList prices={prices} />
          </div>
        )}
      </div>
    </>
  )
}

export default SubscriptionPopup
